module.exports = __webpack_public_path__ + "assets/media/web_browser.775c2aad.svg";